module.exports = __webpack_public_path__ + "img/10_maska_setka-vypuklaya.f21d8cb.svg";